module.exports = __webpack_public_path__ + "img/card-dog-5.a9672517.png";